import { LightDomStyles, OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-footer.css.lit';
import '../outline-container-baseline/outline-container-baseline';

/**
 * The Baseline Footer component.
 * @element outline-footer
 * @slot logo - For logo
 * @slot site-links - For site links
 * @slot footer-links - For footer links
 * @slot address - For address
 * @slot phone - For phone number
 */
@customElement('outline-footer')
export class OutlineFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`
      <footer>
        <outline-container-baseline
          background-color="blue"
          content-max-width="medium"
          y-padding="small"
        >
          <div class="footer-container">
            <div class="footer-top">
              <div class="logo">
                <slot name="logo"></slot>
              </div>
              <div class="site-links-container">
                <div class="site-links">
                  <slot name="site-links"></slot>
                </div>
                <div class="right-links">
                  <div class="contact-link">
                    <slot name="contact"></slot>
                  </div>
                  <div class="social-links">
                    <slot name="social-links"></slot>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator"></div>
            <div class="footer-bottom">
              <div class="footer-links">
                <slot name="footer-links"></slot>
              </div>
              <div class="contact-info">
                <slot name="address"></slot>
                <div class="contact-separator"></div>
                <slot name="phone"></slot>
              </div>
            </div>
          </div>
        </outline-container-baseline>
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-footer': OutlineFooter;
  }
}
